module.exports = __webpack_public_path__ + "img/aeroland-macbook-01.9c993f3f.png";